import React, { Component } from 'react';

class FullPost extends Component {
  render() {

    const {data, postid} = this.props;

    return (
      <div>
        {postid &&
          data.filter(item=>item.id == postid).map( item =>

                <p key={item.id} className="excerpt">
                  {item.content.rendered}
                </p>

          )
        }
      </div>
    );
  }
}

export default FullPost;



// WEBPACK FOOTER //
// ./src/components/fullpost.js